
export enum HttpResponseContent {
  Text = 'text',
  Blob = 'blob',
  Json = 'json',
  ArrayBuffer = 'arraybuffer'
}
